import React from "react";
import { Helmet } from "react-helmet";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";

const About = () => {
  return (
    <main
      className="about-wrapper bg-offWhite"
      style={{
        marginTop: "8rem",
      }}
    >
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="Discover a trusted marketplace for buying and selling digital products. Learn about our mission to empower creators and connect buyers with unique digital content."
        />
      </Helmet>
      <AboutSection />
      <FeaturesSection />
    </main>
  );
};

export default About;
